export const types = {
  BRAND: "brand",
  MODEL: "model",
  COMPANY: "company",
  LOCATION: "location",
  MACHINE_LINE: "machine-line",
  MACHINE_ORIGIN_COUNTRY: "machine-origin-country",
  MACHINE_ACTION_TYPE: "machine-action-type",
  MACHINE_FAULT_TYPE: "machine-fault-type",
};

export const getTypes = (type) => {
  switch (type) {
    case types.BRAND:
      return "machine-brand";
    case types.COMPANY:
      return "machine-company";
    case types.MODEL:
      return "machine-model";
    case types.LOCATION:
      return "machine-location";
    case types.MACHINE_LINE:
      return "machine-line";
    case types.MACHINE_ORIGIN_COUNTRY:
      return "machine-origin-country";
    case types.MACHINE_ACTION_TYPE:
      return "machine-action-type";
    case types.MACHINE_FAULT_TYPE:
      return "machine-fault-type";
    default:
      return "";
  }
};
